var Modal = {
    open: function (modalname) {
        var s = $(window).scrollTop() + 100;
        $('.modal.' + modalname).addClass('is-active').fadeIn(300);
        $('.darkshadow').fadeIn(300);
        $('.modal').css('top', s);
    },
    close: function () {
        $('.modal.is-active, .darkshadow').fadeOut();
        $('.modal.is-active').removeClass('is-active');
    }
}

// Animação para esconder mensagem de sucesso
// if ($('.success')[0] || $('.error')[0])
// {
// 	setTimeout(function(){
// 		$('.success, .error').slideUp();
// 	}, 7000);
// }

$('body').delegate('.darkshadow, .btn-close-modal', 'click', function (event) {
    event.preventDefault();
    Modal.close();
});

$('body').delegate('[rel=modal]', 'click', function (event) {
    event.preventDefault();
    var modalname = $(this).attr("href");
    Modal.open(modalname);
});

$('.m-main-header .peso-jumbo .item label').on('init click', function (e) {
    e.preventDefault();
    var input = $('#' + $(this).attr('for'));
    input.prop('checked', e.type !== 'init' && !input.is(':checked')).trigger('change');
}).trigger('init');

var CNET = {}

CNET.FooterCheck = function () {

    var header = $('.m-main-header').innerHeight() || 0,
        content = $('.page-content').innerHeight() || 0,
        footer = $('.footer-wrap').innerHeight() || 0,
        sum = header + content + footer;

    /*
    if( sum < CNET.pageheight ) {
        $('.footer-wrap').css({"position": "absolute", "bottom" : 0});
    } else {
        $('.footer-wrap').css({"position": "static", "bottom" : "auto"});
    }
    */
};

CNET.prevScroll = 0;

CNET.CheckMenu = function () {
    var header = $('.m-main-header');
    var mainMenu = $('.main-menu');
    // console.log( CNET.prevScroll > CNET.scrolltop );
    if (CNET.prevScroll < CNET.scrolltop) {
        header.addClass('is-mini');
        mainMenu.addClass('is-hidden');
        $('.peso-jumbo').addClass('is-active');
        $('.sobre-o-prazo').addClass('is-active');
        $('.m-main-header .cart').removeClass('is-inactive-mobi');
    } else {
        header.removeClass('is-mini');
        mainMenu.removeClass('is-hidden');
        $('.m-main-header .cart').addClass('is-inactive-mobi');
        $('.peso-jumbo').removeClass('is-active');
        $('.sobre-o-prazo').removeClass('is-active');
    }

    CNET.prevScroll = CNET.scrolltop;
}

CNET._listen = function () {
    var myWindow = $(window);
    var myDocument = $(document);
    CNET.pagewidth = myWindow.width();
    CNET.pageheight = myWindow.height();

    myWindow.resize(function () {
        CNET.pagewidth = myWindow.width();
        CNET.pageheight = myWindow.height();
        CNET.FooterCheck();
    });

    myDocument.ready(function () {
        CNET.FooterCheck();
        CNET.CheckMenu();
    });

    myDocument.scroll(function () {
        CNET.scrolltop = $(document).scrollTop();
        CNET.CheckMenu();
    });
}();

$('.full-banner.owl-carousel').owlCarousel({
    singleItem: true,
    loop: true,
    autoPlay: 5000,
    pagination: true,
    dots: true
});

$('.toggle').click(function (e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.box .inner').removeClass('show');
        $this.parent().parent().find('.box .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});


$('.choose-btn').click(function (e) {
    e.preventDefault();
    var $this = $(this);

    if ($('.entrega-index .m-box-entrega').length) {
        $('.choose-btn').removeClass('checked');
        $('.choose-btn').next().find('.inner').slideUp();
    }

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().parent().slideUp(350);
    } else {
        $this.next().parent().find('.inner').toggleClass('show');
        $this.next().parent().find('.inner').slideToggle(350);
        $this.toggleClass('checked');
    }
});


// new scroll header
// scroll ao subir a página
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.m-main-header').outerHeight();

$(window).scroll(function (event) {
    didScroll = true;
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();

    // Make scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // If scrolled down and past the navbar, add class .nav-up.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('.m-main-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('.m-main-header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}